import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    delegateStaking: 'DELEGATE STAKING',
    apy: 'APY',
    tvl: 'TVL',
    stakers: 'Stakers',
  },
};
